import React from "react";
import commision from "../assets/img/commision.jpeg"

export default function NoCommision() {
    return <div>
        <img src={commision} alt="" style={{ width: "100%" }} />
    </div>;
}
